import React, { FC, ReactNode } from 'react';
import './ExecuteButton.css';
import { FaDochub } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface ExecuteButtonProps {
	onClick: () => void;
	isLoading?: boolean;
	icon?: ReactNode,
	tooltip? : string,
	label ? : string,
}

const ExecuteButton: FC<ExecuteButtonProps> = ({ 
	onClick, 
	isLoading, 
	label = "Executer", 
	icon = <FaDochub />, 
	tooltip = "Bouton d'execution"
}) => (
	<ActionButton
		classNames="ExecuteButton"
		icon={icon}
		label={label}
		onClick={onClick}
		isLoading={isLoading}
		tooltip={tooltip}
		showLabel
	/>
);

export default ExecuteButton;
